<template>
    <div>
        <navbar></navbar>
        <section >
  <div class="container">
    <h1 class="title">
      FAQ
    </h1>
    <h2 class="subtitle">
      Got a Question? Find an answer here.
    </h2>
</div>
</section>
<section>
      <div class="tile is-ancestor">
  <div class="tile is-parent">
  <article class="tile is-child box">
    <p class="title">How much does it cost?</p>
    <p class="subtitle">We are running a <strong>50% OFF</strong> promotion for $24.99 reports! After the promotion, each report is $49.99 . </p>

  </article>
  </div>

  <div class="tile is-parent">
  <article class="tile is-child box">
    <p class="title">What industries and countries do you cover?</p>
    <p class="subtitle">For industries, we support <strong>most</strong> NAICS codes for privately and publicly held companies. We do not support government or municipal NAICS.
    We only support US based geographies: National (current), State(Q2 2020), Zip Codes(Q2 2020).
    </p>

  </article>
  </div>
  <div class="tile is-parent">
  <article class="tile is-child box">
    <p class="title">How are these reports compiled?</p>
    <p class="subtitle">The reports are compiled from public and private sources. We do not disclose methodology or algorithms; however, we will discuss with customers
    in more detail upon NDA and satisfactory due diligence. Please contact us directly for details.
    </p>

  </article>
  </div>

</div>

</section>
<section>
      <div class="tile is-ancestor">
  <div class="tile is-parent">
  <article class="tile is-child box">
    <p class="title">Do you offer subscriptions?</p>
    <p class="subtitle">At the moment, no. We are considering alternate pricing models. Please contact us if you have a specific requirement and we will try to help you.  </p>

  </article>
  </div>

  <div class="tile is-parent">
  <article class="tile is-child box">
    <p class="title">What methods of payment do you accept?</p>
    <p class="subtitle">Currently, we support transactions only through the PayPal platform -- so we accept PayPal, credit cards and checks.
    </p>

  </article>
  </div>
  <div class="tile is-parent">
  <article class="tile is-child box">
    <p class="title">What if my needs are not met by standard reports?</p>
    <p class="subtitle">We can work with customers on a consultative basis; please contact us.
    </p>

  </article>
  </div>

</div>

</section>
    </div>
</template>

<script>
import Navbar from "./features/Navbar"
import SampleReports from "./SampleReports"
import BuyReports from "./BuyReports"

export default {
    name: 'FAQ',
    data() {
        return {
			search: '',
			desc: '',
            books: []
        }
    },
    components: {
        Navbar,
        SampleReports
    },
    mounted() {
        this.fetchBooks();
    },
    methods: {
        fetchBooks() {
        },
        signUp() {
        this.$router.push({ name: "Register" });

        },
        goSampleReports() {
        this.$router.push({ name: "SampleReports" });

        },
	},
}
</script>

<style scoped>
.top-10 {
    margin-top: 10px !important;
}
.grey-background {
    background-color: hsl(0, 0%, 86%) !important;
}

.hero.is-info {
  background: linear-gradient(
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0.5)
    ), url('../assets/images/hero/restaurant-hero.png') no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.hero .nav, .hero.is-success .nav {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.hero .subtitle {
  padding: 3rem 0;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/components/FAQ.vue